import ThemeBackground from "@pathwright/ui/src/components/background/ThemeBackground"
import Carousel from "@pathwright/ui/src/components/carousel/Carousel"
import FullscreenContainer from "@pathwright/ui/src/components/fullscreen/FullscreenContainer"
import { useObserveSizeContext } from "@pathwright/ui/src/components/observers/ObserveSizeContext"
import Portal from "@pathwright/ui/src/components/portal/Portal"
import ScrollView, {
  ScrollContext
} from "@pathwright/ui/src/components/scroll/ScrollView"
import { connect } from "lib/core/store"
import { useEffect, useState } from "react"
import { useHistory } from "react-router-dom"
import StepContainer from "./StepContainer"
import StepSequenceNav from "./StepSequenceNav"

// only rendering active and previously rendered steps to increase performance
function StepSlide({ item: step, index, activeIndex }) {
  const isActive = index === activeIndex
  // We can improve UX by keeping the content rendered once the step
  // has been active. This cuts down on a render flash for Blocks content when
  // switching back to a previously rendered step.
  const [hasRendered, setHasRendered] = useState(isActive)
  useEffect(() => {
    if (isActive && isActive !== hasRendered) setHasRendered(true)
  }, [isActive])

  return isActive || hasRendered ? (
    <StepContainer step={step} index={index} />
  ) : null
}

// have to wrap StepSlider since it uses hooks
function renderItem({ item, index, activeIndex }) {
  return <StepSlide item={item} index={index} activeIndex={activeIndex} />
}

const GroupStepSlider = ({ group, activeIndex }) => {
  const history = useHistory()
  const { getRectValue } = useObserveSizeContext()

  if (group) {
    const onSlideChange = function (activeIndex) {
      if (group) {
        const step = group.items[activeIndex]
        if (step) {
          return history.push(step.url)
        }
      }
    }

    return (
      <FullscreenContainer
        offset={{
          top: getRectValue("alert.height"),
          right: getRectValue("cardstack.width")
        }}
      >
        <Portal portalElementID="fullscreen-theme-portal">
          <ThemeBackground />
        </Portal>
        <StepSequenceNav />
        <ScrollView style={{ position: "relative" }}>
          <ScrollContext.Consumer>
            {({ scrollTo }) => (
              <Carousel
                key={group.id}
                items={group.items}
                itemWidth={window.innerWidth - getRectValue("cardstack.width")}
                renderItem={renderItem}
                activeIndex={activeIndex}
                onChange={(activeIndex) => {
                  scrollTo(0)
                  onSlideChange(activeIndex)
                }}
              />
            )}
          </ScrollContext.Consumer>
        </ScrollView>
      </FullscreenContainer>
    )
  } else {
    return <div />
  }
}

GroupStepSlider.displayName = "GroupStepSlider"

const mapStateToProps = function ({ stepStore }, ownProps) {
  const { group, step, active_step_index } = stepStore.state

  return _.assign(
    {},
    {
      activeIndex: active_step_index,
      group
    },
    ownProps
  )
}

export default connect(GroupStepSlider, "step", mapStateToProps, ["step"])
